<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28" fill="none">
    <path
      d="M16.5 0l7 7v15.6c0 2.25 0 3.375-.573 4.164a3 3 0 0 1-.663.663C21.475 28 20.349 28 18.1 28H5.9c-2.25 0-3.375 0-4.164-.573a3 3 0 0 1-.663-.663C.5 25.975.5 24.849.5 22.6V5.4c0-2.25 0-3.375.573-4.164a3 3 0 0 1 .663-.663C2.525 0 3.651 0 5.9 0h10.6z"
      fill="url(#paint0_linear_4691_18172)"
    />
    <path
      d="M16.5 0l7 7h-3.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16.5 5.48 16.5 4.92 16.5 3.8V0z"
      fill="#fff"
      fill-opacity=".55"
    />
    <path
      d="M16.72 18.7a4.618 4.618 0 0 1-2.678-1.086c-1.484.326-2.896.796-4.307 1.375-1.122 1.99-2.172 3.004-3.077 3.004-.18 0-.398-.036-.543-.145a1.067 1.067 0 0 1-.615-.977c0-.325.072-1.23 3.51-2.714a25.767 25.767 0 0 0 1.919-4.488c-.434-.869-1.375-3.004-.724-4.09.217-.398.652-.615 1.122-.579a1.2 1.2 0 0 1 .941.47c.47.652.434 2.027-.18 4.054a10.916 10.916 0 0 0 2.243 2.896c.76-.145 1.52-.254 2.28-.254 1.701.036 1.955.833 1.918 1.303 0 1.23-1.194 1.23-1.81 1.23zM6.586 20.944l.108-.037c.507-.18.905-.543 1.195-1.013a2.86 2.86 0 0 0-1.303 1.05zm4.813-10.858h-.108c-.036 0-.109 0-.145.036-.145.615-.036 1.267.217 1.846a3.041 3.041 0 0 0 .036-1.882zm.254 5.248l-.036.072-.037-.036a29.881 29.881 0 0 1-1.085 2.461l.072-.036v.072c.796-.29 1.665-.543 2.461-.724l-.036-.036h.108a11.088 11.088 0 0 1-1.447-1.773zm4.922 1.918c-.326 0-.615 0-.941.072.362.181.724.254 1.086.29a1.6 1.6 0 0 0 .724-.073c0-.108-.145-.29-.869-.29z"
      fill="#fff"
    />
    <defs>
      <linearGradient id="paint0_linear_4691_18172" x1="1.5" y1="-1" x2="23.5" y2="28" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FD6D3A" />
        <stop offset="1" stop-color="#F05A6B" />
      </linearGradient>
    </defs>
  </svg>
</template>
